import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { EmployerBrandingPersonaPage } from "@/components/site/EmployerBrandingPersonaPage";
import { EMPLOYER_BRANDING_META_DESCRIPTION } from "@/content/meta/EmployerBrandingPersonaPage";

export const Route = createFileRoute("/who-we-help/employer-branding-experts")({
  head: () => ({
    meta: [
      { title: "Media Intelligence for Employer Branding Experts | Perceptica" },
      { name: "description", content: EMPLOYER_BRANDING_META_DESCRIPTION },
      { property: "og:title", content: "Media Intelligence for Employer Branding Experts | Perceptica" },
      { property: "og:description", content: EMPLOYER_BRANDING_META_DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Media Intelligence for Employer Branding Experts | Perceptica" },
      { name: "twitter:description", content: EMPLOYER_BRANDING_META_DESCRIPTION },
      { property: "og:url", content: "https://perceptica.com/who-we-help/employer-branding-experts" },
      ...ogImageMeta("en", "/who-we-help/employer-branding-experts"),
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/who-we-help/employer-branding-experts" }),
  }),
  component: EmployerBrandingPersonaPage,
});
